/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportTransactionAcquisition } from '../fn/transaction-acquisition/export-transaction-acquisition';
import { ExportTransactionAcquisition$Params } from '../fn/transaction-acquisition/export-transaction-acquisition';
import { getTransactionAcquisition } from '../fn/transaction-acquisition/get-transaction-acquisition';
import { GetTransactionAcquisition$Params } from '../fn/transaction-acquisition/get-transaction-acquisition';
import { searchTransactionAcquisition$Any } from '../fn/transaction-acquisition/search-transaction-acquisition-any';
import { SearchTransactionAcquisition$Any$Params } from '../fn/transaction-acquisition/search-transaction-acquisition-any';
import { searchTransactionAcquisition$Json } from '../fn/transaction-acquisition/search-transaction-acquisition-json';
import { SearchTransactionAcquisition$Json$Params } from '../fn/transaction-acquisition/search-transaction-acquisition-json';
import { searchTransactionAcquisitionSummary } from '../fn/transaction-acquisition/search-transaction-acquisition-summary';
import { SearchTransactionAcquisitionSummary$Params } from '../fn/transaction-acquisition/search-transaction-acquisition-summary';
import { searchTransactionAcquisitionSummaryHistory$Any } from '../fn/transaction-acquisition/search-transaction-acquisition-summary-history-any';
import { SearchTransactionAcquisitionSummaryHistory$Any$Params } from '../fn/transaction-acquisition/search-transaction-acquisition-summary-history-any';
import { searchTransactionAcquisitionSummaryHistory$Json } from '../fn/transaction-acquisition/search-transaction-acquisition-summary-history-json';
import { SearchTransactionAcquisitionSummaryHistory$Json$Params } from '../fn/transaction-acquisition/search-transaction-acquisition-summary-history-json';
import { TransactionAcquisition } from '../models/transaction-acquisition';
import { TransactionAcquisitionPagedList } from '../models/transaction-acquisition-paged-list';
import { TransactionAcquisitionSummaryPagedList } from '../models/transaction-acquisition-summary-paged-list';


/**
 * All about the station's transaction acquisition
 */
@Injectable({ providedIn: 'root' })
export class TransactionAcquisitionService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchTransactionAcquisitionSummary()` */
  static readonly SearchTransactionAcquisitionSummaryPath = '/custom/stations/transaction-acquisition/summary/search';

  /**
   * Search transaction's acquisition summary, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionAcquisitionSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchTransactionAcquisitionSummary$Response(params?: SearchTransactionAcquisitionSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionSummaryPagedList>> {
    return searchTransactionAcquisitionSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * Search transaction's acquisition summary, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionAcquisitionSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchTransactionAcquisitionSummary(params?: SearchTransactionAcquisitionSummary$Params, context?: HttpContext): Observable<TransactionAcquisitionSummaryPagedList> {
    return this.searchTransactionAcquisitionSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionAcquisitionSummaryPagedList>): TransactionAcquisitionSummaryPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactionAcquisitionSummaryHistory()` */
  static readonly SearchTransactionAcquisitionSummaryHistoryPath = '/custom/stations/transaction-acquisition/summary-history/search';

  /**
   * Search transaction's acquisition history summurized, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionAcquisitionSummaryHistory$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionAcquisitionSummaryHistory$Json$Response(params?: SearchTransactionAcquisitionSummaryHistory$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionSummaryPagedList>> {
    return searchTransactionAcquisitionSummaryHistory$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search transaction's acquisition history summurized, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionAcquisitionSummaryHistory$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionAcquisitionSummaryHistory$Json(params?: SearchTransactionAcquisitionSummaryHistory$Json$Params, context?: HttpContext): Observable<TransactionAcquisitionSummaryPagedList> {
    return this.searchTransactionAcquisitionSummaryHistory$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionAcquisitionSummaryPagedList>): TransactionAcquisitionSummaryPagedList => r.body)
    );
  }

  /**
   * Search transaction's acquisition history summurized, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionAcquisitionSummaryHistory$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionAcquisitionSummaryHistory$Any$Response(params?: SearchTransactionAcquisitionSummaryHistory$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionSummaryPagedList>> {
    return searchTransactionAcquisitionSummaryHistory$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search transaction's acquisition history summurized, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionAcquisitionSummaryHistory$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionAcquisitionSummaryHistory$Any(params?: SearchTransactionAcquisitionSummaryHistory$Any$Params, context?: HttpContext): Observable<TransactionAcquisitionSummaryPagedList> {
    return this.searchTransactionAcquisitionSummaryHistory$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionAcquisitionSummaryPagedList>): TransactionAcquisitionSummaryPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactionAcquisition()` */
  static readonly SearchTransactionAcquisitionPath = '/custom/stations/transaction-acquisition/search';

  /**
   * Search transaction's acquisition, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionAcquisition$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionAcquisition$Json$Response(params?: SearchTransactionAcquisition$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionPagedList>> {
    return searchTransactionAcquisition$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search transaction's acquisition, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionAcquisition$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionAcquisition$Json(params?: SearchTransactionAcquisition$Json$Params, context?: HttpContext): Observable<TransactionAcquisitionPagedList> {
    return this.searchTransactionAcquisition$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionAcquisitionPagedList>): TransactionAcquisitionPagedList => r.body)
    );
  }

  /**
   * Search transaction's acquisition, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionAcquisition$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionAcquisition$Any$Response(params?: SearchTransactionAcquisition$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionPagedList>> {
    return searchTransactionAcquisition$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search transaction's acquisition, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionAcquisition$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionAcquisition$Any(params?: SearchTransactionAcquisition$Any$Params, context?: HttpContext): Observable<TransactionAcquisitionPagedList> {
    return this.searchTransactionAcquisition$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionAcquisitionPagedList>): TransactionAcquisitionPagedList => r.body)
    );
  }

  /** Path part for operation `exportTransactionAcquisition()` */
  static readonly ExportTransactionAcquisitionPath = '/custom/stations/transaction-acquisition/export';

  /**
   * Export the transaction's acquisition as an XLSX File.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTransactionAcquisition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTransactionAcquisition$Response(params?: ExportTransactionAcquisition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportTransactionAcquisition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transaction's acquisition as an XLSX File.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportTransactionAcquisition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTransactionAcquisition(params?: ExportTransactionAcquisition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportTransactionAcquisition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getTransactionAcquisition()` */
  static readonly GetTransactionAcquisitionPath = '/custom/stations/transaction-acquisition/{uid}';

  /**
   * Get a simple transaction's acquisition.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionAcquisition()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionAcquisition$Response(params: GetTransactionAcquisition$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisition>> {
    return getTransactionAcquisition(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple transaction's acquisition.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionAcquisition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionAcquisition(params: GetTransactionAcquisition$Params, context?: HttpContext): Observable<TransactionAcquisition> {
    return this.getTransactionAcquisition$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionAcquisition>): TransactionAcquisition => r.body)
    );
  }

}
